import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NavbarProps {
    hideSignBtn?: boolean;
    // Where the logo navigates. Defaults to home ('/'); flow pages (e.g. the
    // accounting "operate" onboarding) pass their own dashboard so the logo
    // takes the user back to the dashboard matching that flow.
    logoTo?: string;
}

export default function Navbar({ hideSignBtn, logoTo }: NavbarProps) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const isRTL = i18n.language === 'ar';

    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(newLang);
    };

    const handleLogoClick = () => {
        navigate(logoTo || '/');
    };

    // Get current location path
    const location = useLocation();
    const isPrice2 = location.pathname === '/pricing2';

    const handleLogout = () => {
        // Clear auth logic locally if clearAuth is not available or just import it.
        // Assuming clearAuth is available based on other files, but to be safe and avoid compilation errors if imports fail, I can verify first.
        // Or I can just clear localStorage directly here which is safer for a one-off without verifying imports.
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('authTokens');
        localStorage.removeItem('idToken');
        localStorage.removeItem('refreshToken');
        navigate('/');
    };

    return (
        <>
            <header className="sticky top-0 z-50 flex items-center justify-between px-12 py-4 bg-white shadow-sm">
                <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
                    <img
                        src="https://storage.googleapis.com/connct-cba18.firebasestorage.app/frontend-assets/Conncct-logo.png"
                        alt="Conncct"
                        className="h-8 w-auto"
                    />
                </div>
                <div className="flex items-center gap-6">
                    <button
                        onClick={toggleLanguage}
                        className="text-gray-600 text-sm hover:text-gray-900 transition-colors"
                    >
                        {i18n.language === 'ar' ? 'English' : 'العربية'}
                    </button>
                    {!hideSignBtn && (
                        isPrice2 ? (
                            <button
                                onClick={handleLogout}
                                className="bg-blue-600 text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors"
                            >
                                {t('nav.logout', 'Logout')}
                            </button>
                        ) : (
                            <Link to="/login" className="bg-blue-600 text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors">
                                {t('nav.signIn')}
                            </Link>
                        )
                    )}
                </div>
            </header>
        </>
    )
}